import { api } from "lwc";

import Button, { Variant } from "tds/button";
import { PopoverPlacement } from "common/popover";
import { BooleanAttr, attrToBool } from "common/helpers";

export type Shape = "default" | "circle";

export default class extends Button {
  @api variant: Variant = "tertiary";
  @api shape: Shape = "default";
  @api tooltipPlacement: PopoverPlacement = "top";

  private _hasPopup = false;
  @api
  get hasPopup() {
    return this._hasPopup;
  }

  set hasPopup(newValue: BooleanAttr) {
    this._hasPopup = attrToBool(newValue);
  }

  private _popupOpen = false;
  @api
  get popupOpen() {
    return this._popupOpen;
  }

  set popupOpen(newValue: BooleanAttr) {
    this._popupOpen = attrToBool(newValue);
  }

  private _tooltipDisabled = false;
  @api
  get tooltipDisabled() {
    return this._tooltipDisabled;
  }

  private get ariaExpandedAttr() {
    // Buttons without popup shouldn't have the aria-expanded attribute at all.
    return this.hasPopup ? String(this._popupOpen) : undefined;
  }

  set tooltipDisabled(newValue: BooleanAttr) {
    this._tooltipDisabled = attrToBool(newValue);
  }

  private get shapeClassName() {
    return this.shape !== "default" ? `button--${this.shape}` : "";
  }

  get className() {
    return `${super.className} ${this.shapeClassName}`.trim();
  }

  renderedCallback() {
    // Disable browser UI since custom tooltips are included
    this.removeAttribute("title");
  }

  private handleMouseDown() {
    this._tooltipDisabled = true;
  }

  private handleMouseUp() {
    this._tooltipDisabled = false;
  }
}
